module.exports = __webpack_public_path__ + "img/far-search.194f50be.svg";